import React from 'react';
import { I18n } from '../../../helpers/i18n';
import starInactive from '../../../static/images/mvp/star_in_active.png';
import './TotalRatingsComponent.css';

/**
 * Inline session/topic rating display: star + average score + count (or "no rating").
 * Clickable to open rating list popup.
 */
function TotalRatingsComponent({
  totalPointEvaluating = 0,
  totalEvaluating = 0,
  onClick,
  style = {},
  isSmallStar = false,
}) {
  return (
    <span className="total-ratings-clickable" onClick={onClick} style={style}>
      <img src={starInactive} className={`total-ratings-star-image ${isSmallStar ? 'small' : ''}`} alt="rating" />
      {totalEvaluating > 0 ? (
        <>
          <span className="total-ratings-points-text">{totalPointEvaluating}</span>
          <span className="total-ratings-count">
            ({totalEvaluating.toLocaleString()} {I18n.t('ratings_count')})
          </span>
        </>
      ) : (
        <span className="total-ratings-none">{I18n.t('no_rating')}</span>
      )}
    </span>
  );
}

export default TotalRatingsComponent;
